// Translations
import form from '../sections/form/translations/ar'

// Translation: Two-factor authentication > Landing (Arabic)
export default Object.freeze({
	sections: { form }
})
